import { components } from "src/types/xRM/generated"

export const formatPrice = (
  price?: number | null,
  locale?: string | null,
  currency?: string | null,
) => {
  const formatter = new Intl.NumberFormat(locale ?? "de-DE", {
    style: "currency",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    currency: currency ?? "EUR",
  })
  return price != null ? formatter.format(price) : "-"
}

interface CalculatePriceProps {
  calculationMethod: components["schemas"]["ProductCalculation"] | undefined
  price: number
  duration?: number
  quantity?: number
  assignedStandSize?: number
}

export const calculatePrice = ({
  calculationMethod = "Fix",
  price,
  quantity = 1,
  duration,
  assignedStandSize = 0,
}: CalculatePriceProps) => {
  if (calculationMethod === "Fix" || !duration) {
    return price * quantity
  } else {
    return price * duration * assignedStandSize
  }
}

/**
 * [x] get selected booking
 * [x] get quantity of selected booking
 * [x] get exhibition duration
 * [x] get price per unit
 * [x] calculate: price per unit * quantity * exhibition duration
 * [] add flag to product (API)
 * [] edit enum to match XRM optionSet
 * [] check for flag
 * [] if flag is true, disable quantity input
 * [] show estimated price if no booking is selected
 *
 * Files: ShopDetailHeaderContent.tsx
 */

/**
 * eInvoice
 * [x] add eInvoice field to cart
 * [] add changes to API
 * [] test if fe sends data to api
 *
 * Files: ShopCartOverviewSummary.tsx, ShopCartOverviewBillingOptionsCard.tsx
 */
